/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { TFunction } from "i18next";
import Tab from "@mui/material/Tab";

import {
  AllInclusiveIcon,
  FilterOutlineIcon,
  PlaylistAddCheckIcon
} from "@dotnet/telematics-design-system";

import { TABLE_NAMES, useMediaQueries } from "../../../../../../../shared";
import SegmentedToggle from "../../../../../../SegmentedToggle/SegmentedToggle";
import { SEGMENTED_TOGGLE_TAB_SIZES } from "../../../../../../SegmentedToggle/types";

interface SchedulesSourceTabsProps {
  tabValue: number;
  onTabChange: (_event: React.ChangeEvent<{}>, newValue: number) => void;
  t: TFunction<"translation", undefined>;
  disableSelectedTab: boolean;
  disableFilteredTab: boolean;
  resourceName: TABLE_NAMES;
}

const SchedulesSourceTabs = ({
  tabValue,
  onTabChange,
  t,
  disableSelectedTab,
  disableFilteredTab,
  resourceName
}: SchedulesSourceTabsProps) => {
  const { fromSm } = useMediaQueries();

  return (
    <SegmentedToggle
      data-testid="tri-source-tabs"
      value={tabValue}
      size={SEGMENTED_TOGGLE_TAB_SIZES.Small}
      fullWidth={fromSm}
      tabWidth="277px"
      onChange={onTabChange}
      css={css({ marginBottom: "16px" })}
    >
      <Tab
        data-testid="selected-items-tab"
        label={t("Button##selected")}
        icon={<PlaylistAddCheckIcon />}
        className={disableSelectedTab ? undefined : "enabled"}
        disabled={disableSelectedTab}
      />

      <Tab
        data-testid="filtered-items-tab"
        label={t("Button##filtered")}
        icon={<FilterOutlineIcon />}
        className={disableFilteredTab ? undefined : "enabled"}
        disabled={disableFilteredTab}
      />
      <Tab
        data-testid="all-items-tab"
        label={t(`Button##all ${resourceName}`)}
        icon={<AllInclusiveIcon />}
        className="enabled"
        disabled={false}
      />
    </SegmentedToggle>
  );
};

export default SchedulesSourceTabs;
